import { createSelector } from '@ngrx/store';

import { IAppState } from '../states/app.state';
import { IMerchantState } from '../states/merchant.state';

const MerchantState = (state: IAppState) => state.merchant;

export const selectMerchant = createSelector(
    MerchantState,
  (state:IMerchantState) =>  state.Merchant?.data
);